import aes from 'crypto-js/aes'
import utf8 from 'crypto-js/enc-utf8'

import type { LoginCredentials } from '../types/user'

const USER_KEY = import.meta.env.VITE_USER_ENCRYPTION_KEY
const USER_KEY_OLD = import.meta.env.VITE_USER_ENCRYPTION_KEY_OLD as string
const REMEMBERED_KEY = import.meta.env.VITE_REMEMBERED_CREDENTIALS_STORAGE_KEY

const tryDecrypt = (cipher: string, key: string): LoginCredentials | null => {
  try {
    return JSON.parse(aes.decrypt(cipher, key).toString(utf8)) as LoginCredentials
  } catch {
    return null
  }
}

export const encryptUser = (user: LoginCredentials) => {
  localStorage.setItem(
    'user',
    aes.encrypt(JSON.stringify(user), USER_KEY).toString(),
  )
}

export const decryptUser = (): null | LoginCredentials => {
  const stored = localStorage.getItem('user')
  if (!stored) return null

  const fromNew = tryDecrypt(stored, USER_KEY)
  if (fromNew) return fromNew

  // Key-rotation fallback: transparently migrate old-key data. Remove once migration window closes.
  if (USER_KEY_OLD) {
    const fromOld = tryDecrypt(stored, USER_KEY_OLD)
    if (fromOld) {
      encryptUser(fromOld)
      return fromOld
    }
  }

  localStorage.removeItem('user')
  return null
}

export const clearUser = () => {
  localStorage.removeItem('user')
  localStorage.removeItem('privateAuth')
}

export const rememberCredentials = (user: LoginCredentials) => {
  localStorage.setItem(
    REMEMBERED_KEY,
    aes.encrypt(JSON.stringify(user), USER_KEY).toString(),
  )
}

export const getRememberedCredentials = (): LoginCredentials | null => {
  const stored = localStorage.getItem(REMEMBERED_KEY)
  if (!stored) return null
  try {
    return JSON.parse(aes.decrypt(stored, USER_KEY).toString(utf8)) as LoginCredentials
  } catch {
    return null
  }
}

export const clearRememberedCredentials = () => {
  localStorage.removeItem(REMEMBERED_KEY)
}

export const validateEmail = (email: string) => {
  const allowedChars = /^[A-Za-z0-9!#$%&'*+\-/=?^_`{|}"()<>@[\]\\,;:.]+$/

  if (!allowedChars.test(email)) {
    return null
  }

  return email.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  )
}
